import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useCategoriesNavigationContext } from './StoryblokCategoryNavigationProvider'

export const StoryblokCategoryNavigationButton: FC = () => {
  const { handleOpen } = useCategoriesNavigationContext()

  return (
    <Button className="w-full" onClick={handleOpen}>
      <FormattedMessage id="general.label.categories" />
    </Button>
  )
}
